import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { AppState } from '../../store';
import { callHomingService, setIsSuspendedDevice } from '../../store/devices/actions';
import { commandsActionNames } from '../../store/commands/types';
import { searchActionNames } from '../../store/search/types';
import { setModalOpen } from '../../store/modal/actions';
import { NavSection } from '../../globals/nav-list';

const HomingService = ({ navList }: { navList: NavSection | null }) => {
  const dispatch = useDispatch();
  const deviceKey = useSelector((state: AppState) => state.search.selectedEntity?.deviceKey);
  const [previousKey, setPreviousKey] = useState('');
  const sessionHistory = useSelector((state: AppState) => state.userPreference.sessionHistory);
  const { envVariables } = useSelector((state: AppState) => state.login);
  const { page } = useParams<{ page: string }>();
  const homingService = useSelector((state: AppState) => state.devices.homingService);
  const history = useHistory();
  const location = useLocation();

  const notMigrated = (
    <p>
      WARNING: Device Not Yet Migrated, Transactions can be displayed however Device Configuration
      functionality (e.g. sending commands) will be disabled until this device is migrated. Please
      go to{' '}
      <a
        href={envVariables.legacyMMSGatewaySupportPortalLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        Legacy MMS Gateway Support Portal
      </a>
      to perform anything Device Configuration related
    </p>
  );

  const notFound = <p>Issues retrieving device information, please try again</p>;

  const suspendedDevice = <p>Device Suspended, all features except Device Configuration will be enabled</p>;

  const deviceChange = () => {
    const pageSource: any = navList && navList[page];
    const pageAcceptsDevices = pageSource && pageSource.path.includes('/:deviceId?');
    if (
      deviceKey &&
      deviceKey !== previousKey &&
      !homingService.proposedRoute &&
      pageAcceptsDevices
    ) {
      setPreviousKey(deviceKey);
      dispatch(callHomingService(deviceKey));
    }
  };

  useEffect(() => {
    deviceChange();
  }, [deviceKey]);

  const pushRoute = () => {
    if (homingService.proposedRoute) {
      history.push(`${homingService.proposedRoute}`);
    }
  };

  const handleDialogConfirmation = () => {
    pushRoute();
    dispatch({
      type: commandsActionNames.HIDE_DEVICE_CONFIGURATION,
    });
    if (homingService.option)
      dispatch({
        type: searchActionNames.SET_SELECTED_ENTITY,
        payload: homingService.option,
      });
    dispatch({
      type: commandsActionNames.HIDE_DEVICE_CONFIGURATION,
    });
  };

  const handleDialogCancel = () => {
    const historyKeys = sessionHistory && Object.keys(sessionHistory);
    if (historyKeys && historyKeys.length === 1) history.push(``);
  };

  const openModel = (message: JSX.Element | string) => {
    const acceptButtonText: string = homingService.isDeviceNotPresent ? 'Ok' : 'Confirm';
    dispatch(
      setModalOpen({
        open: true,
        message,
        cancel: handleDialogCancel,
        accept: handleDialogConfirmation,
        acceptButtonText,
      }),
    );
  };

  useEffect(() => {
    if (location.pathname === '/' || location.pathname.includes(homingService.page || page)) {
      if (homingService.error === 451) {
        openModel(suspendedDevice);
      }
      else {
        pushRoute();
      }
    }
  }, [homingService]);

  return <></>;
};
export default HomingService;
